import { createAsyncThunk } from '@reduxjs/toolkit';
import { tr } from '../../../i18n/i18n';
import i18n from '../../../i18n/i18n';
import { AxiosError } from 'axios';
import {
  IGetAdminStudentsResponse,
  IGetAdminStudentsParams,
  IGetAdminStudentByIdResponse,
  IUpdateAdminStudentResponse,
  IUpdateAdminStudentPayload,
} from '../../../interface/classveew-admin/admin-management.interface';
import { IErrorResponse, IApiErrorResponse } from '../../../interface/main.interface';
import {
  getAdminStudents,
  getAdminStudentById,
  updateAdminStudent,
} from '../../../services/classveew-admin';

/**
 * Fetch all admin students with optional query parameters
 */
export const fetchAdminStudents = createAsyncThunk<
  IGetAdminStudentsResponse,
  IGetAdminStudentsParams,
  { rejectValue: IErrorResponse }
>('admin-student/fetch-all', async (params, { rejectWithValue }) => {
  try {
    const response = await getAdminStudents(params);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IApiErrorResponse>;
    const errorData = error.response?.data || (error as IApiErrorResponse);
    return rejectWithValue({
      status: error.response?.status || errorData?.statusCode || 500,
      message: Array.isArray(errorData?.message)
        ? errorData.message.join(', ')
        : errorData?.message ||
          i18n.t('toast.failed_to_fetch_students', 'Failed to fetch students.'),
    });
  }
});

/**
 * Fetch a single admin student by ID
 */
export const fetchAdminStudentById = createAsyncThunk<
  IGetAdminStudentByIdResponse,
  string,
  { rejectValue: IErrorResponse }
>('admin-student/fetch-by-id', async (studentId, { rejectWithValue }) => {
  try {
    const response = await getAdminStudentById(studentId);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IApiErrorResponse>;
    const errorData = error.response?.data || (error as IApiErrorResponse);
    return rejectWithValue({
      status: error.response?.status || errorData?.statusCode || 500,
      message: Array.isArray(errorData?.message)
        ? errorData.message.join(', ')
        : errorData?.message || tr('g.failed_to_fetch_student', 'Failed to fetch student.'),
    });
  }
});

/**
 * Update an admin student profile
 */
export const updateAdminStudentProfile = createAsyncThunk<
  IUpdateAdminStudentResponse,
  { studentId: string; data: IUpdateAdminStudentPayload },
  { rejectValue: IErrorResponse }
>('admin-student/update', async ({ studentId, data }, { rejectWithValue }) => {
  try {
    const response = await updateAdminStudent(studentId, data);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IApiErrorResponse>;
    const errorData = error.response?.data || (error as IApiErrorResponse);
    return rejectWithValue({
      status: error.response?.status || errorData?.statusCode || 500,
      message: Array.isArray(errorData?.message)
        ? errorData.message.join(', ')
        : errorData?.message ||
          i18n.t('toast.failed_to_update_student', 'Failed to update student.'),
    });
  }
});
